<ds-modal
  #imprintModal
  [ds-modal-trigger-for]="imprintModal"
  [isModalOpen]="modalIsOpen()"
  [isDismissable]="true"
  (isModalOpenChange)="modalIsOpen.set($event)"
>
  <ds-box-header size="md" >Imprint</ds-box-header>
  <ds-box-content>
    <p class="text-regular mb-4x">{{ 'header.imprint.operatedBy' | translate }} Bayerische Motoren Werke Aktiengesellschaft, Petuelring 130, 80788 Munich, Germany.</p>

    <p class="text-regular d-block">{{ 'header.imprint.contact' | translate }}: <a href="mailto:itsd-german@bmw.com">itsd-german&#64;bmw.com</a> & <a href="mailto:itsd-english@bmw.com">itsd-english&#64;bmw.com</a></p>
    <p class="text-regular">{{ 'header.imprint.phone' | translate }}: +49 89 382 55555</p>
    <p class="text-regular mb-4x">{{ 'header.imprint.availability' | translate }}</p>

    <p class="text-regular mb-4x">{{ 'header.imprint.representedBy' | translate }} Board of Management: Milan Nedeljkovic (Chairman), Jochen Goller, Dorothea von Boxberg, Walter Mertl, Raymond Wittmann, Joachim Post, Frank Weber.</p>

    <p class="text-regular mb-4x">{{ 'header.imprint.chairMan' | translate }}: Nicolas Peter</p>

    <p class="text-regular d-block">{{ 'header.imprint.commercialRegister' | translate }}: Munich Local Court Register court HRB 42243</p>
    <p class="text-regular">{{ 'header.imprint.vat' | translate }}: DE 129273398</p>
  </ds-box-content>
  <ds-box-footer>
    <button ds-button variant="primary" (click)="modalIsOpen.set(false)">
      {{ 'common.buttons.close' | translate }}
    </button>
  </ds-box-footer>
</ds-modal>
